<script>
import Thumbnail from 'dashboard/components/widgets/Thumbnail.vue';

export default {
  components: {
    Thumbnail,
  },
  props: {
    agentList: {
      type: Array,
      default: () => [],
    },
    selectedAgents: {
      type: Array,
      default: () => [],
    },
    updateSelectedAgents: {
      type: Function,
      default: () => {},
    },
    isWorking: {
      type: Boolean,
      default: false,
    },
    submitButtonText: {
      type: String,
      default: '',
    },
    showSubmitButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    selectedAgentCount() {
      return this.selectedAgents.length;
    },
    allAgentsSelected() {
      return this.selectedAgents.length === this.agentList.length;
    },
    disableSubmitButton() {
      return this.selectedAgentCount === 0;
    },
  },
  methods: {
    isAgentSelected(agentId) {
      return this.selectedAgents.includes(agentId);
    },
    handleSelectAgent(agentId) {
      const shouldRemove = this.isAgentSelected(agentId);

      let result = [];
      if (shouldRemove) {
        result = this.selectedAgents.filter(item => item !== agentId);
      } else {
        result = [...this.selectedAgents, agentId];
      }

      this.updateSelectedAgents(result);
    },
    selectAllAgents() {
      if (this.allAgentsSelected) {
        this.updateSelectedAgents([]);
      } else {
        const result = this.agentList.map(item => item.id);
        this.updateSelectedAgents(result);
      }
    },
    agentRowClass(agentId) {
      return { 'is-active': this.isAgentSelected(agentId) };
    },
  },
};
</script>

<template>
  <div>
    <div class="add-agents__header" />

    <div class="setting-table-container">
      <!-- Header table (không cuộn) -->
      <table class="w-full">
        <thead>
          <tr>
            <th class="w-12">
              <div class="flex items-center">
                <input
                  name="select-all-agents"
                  type="checkbox"
                  :checked="allAgentsSelected"
                  :title="allAgentsSelected ? $t('TEAMS_SETTINGS.AGENTS.DESELECT_ALL') : $t('TEAMS_SETTINGS.AGENTS.SELECT_ALL')"
                  @click.self="selectAllAgents"
                />
              </div>
            </th>
            <th class="text-left text-slate-800 dark:text-slate-100">
              {{ $t('TEAMS_SETTINGS.AGENTS.AGENT') }}
            </th>
          </tr>
        </thead>
      </table>

      <!-- Body table (cuộn trong container riêng) -->
      <div class="agent-list-scroll">
        <table class="w-full">
          <tbody>
            <tr
              v-for="agent in agentList"
              :key="agent.id"
              :class="agentRowClass(agent.id)"
              class="agent-row"
            >
              <td class="w-12">
                <div class="flex items-center">
                  <input
                    type="checkbox"
                    :checked="isAgentSelected(agent.id)"
                    @click.self="() => handleSelectAgent(agent.id)"
                  />
                </div>
              </td>
              <td>
                <div class="flex items-center gap-2">
                  <Thumbnail
                    :src="agent.thumbnail"
                    size="24px"
                    :username="agent.name"
                    :status="agent.availability_status"
                  />
                  <div class="flex flex-col text-left">
                    <h4 class="text-base mb-0 text-slate-800 dark:text-slate-100">
                      {{ agent.name }}
                    </h4>
                    <span class="text-sm text-slate-600 dark:text-slate-300">
                      {{ agent.email || '---' }}
                    </span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="showSubmitButton" class="flex flex-col items-center justify-between mt-6">
      <woot-submit-button
        class="!bg-n-bluegray-4 dark:!bg-n-bluegray-4 !text-white dark:!text-white"
        :button-text="submitButtonText"
        :loading="isWorking"
        :disabled="disableSubmitButton"
      />
    </div>
  </div>
</template>

<style scoped>
input {
  @apply mb-0;
}

.setting-table-container table {
  border-collapse: separate;
  border-spacing: 0;
}

.agent-list-scroll {
  max-height: 16rem;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

.setting-table-container thead {
  @apply bg-white dark:bg-n-vars-black-br;
}

.agent-row {
  @apply cursor-pointer transition-all duration-200;
}
.agent-row:hover {
  @apply bg-n-gray-1 dark:bg-n-vars-black-bd/80;
}
.agent-row.is-active {
  @apply bg-n-gray-1 dark:bg-n-vars-black-bd/80;
}
</style>